module.exports = __webpack_public_path__ + "static/media/03.848aa4a1.png";